import { AppAreaConfig } from '@/funnels/@types'
import maleTaiChiWalkingAl from './activity-male-tai-chi-walking-al'
import femaleTaiChiWalkingV2Al from './activity-female-tai-chi-walking-v2-al'

const appAreaConfig: AppAreaConfig = {
	appArea: 'main-tai-chi-walking-al',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['tai_chi_walking'],
	},
	landing: {
		ids: ['loader-tai-chi-walking', 'age-tai-chi-walking'],
		route: {
			path: '/tai-chi-walking-al',
			name: 'main-tai-chi-walking-funnel-al',
		},
	},
	funnel: {
		id: 'ob-tai-chi-walking-gender-selection',
		route: {
			path: '/tai-chi-walking-al/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'tai-chi-walking-survey-al',
		},
		slug: 'main-tai-chi-walking-al',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
		redirectTo: {
			sex: {
				male: { appArea: maleTaiChiWalkingAl },
				female: { appArea: femaleTaiChiWalkingV2Al },
			},
		},
	},
}

export default appAreaConfig
